<template lang="pug" src="./custom-braces-dodont.pug"></template>

<script>
export default {
  props: ['content']
}
</script>



// WEBPACK FOOTER //
// custom-braces-dodont.vue?f10156ca